// 世界史スポット（歴史的名所）データ + 最寄り/近傍ヘルパ。
//
// データ本体は historicSitesData.js（各フィールドの説明もそちらの冒頭にある）。
// ヘルパは airports.js と同じ設計：起動時に一度だけ ENU 座標へ前計算し、毎フレームは
// 二乗距離のスキャンだけで済ませる（sqrt は勝者の1回のみ）。
import { HISTORIC_SITES } from './historicSitesData.js';
import { nearestPoi } from './geo.js';

export const TOTAL_SITES = HISTORIC_SITES.length;

// リングの既定寸法。site 側の ringRadiusM / ringAglM で個別に上書きできる
// （谷底の遺跡など、既定では輪が地形に埋まる場所のための逃げ道）。
//
// 輪は地表 100m〜600m を占める。名所の「すぐ上」に置くのが狙いで、中心高度
// 350m は遺跡そのものを見下ろせる高さ。これより高いと、くぐった瞬間に名所が
// 豆粒になって学習の役に立たない。下端 100m は建物や起伏を避けるための余裕。
// ※ この高さだと、出発地が名所とほぼ同じ座標のときスポーン地点（地表 +250m）が
//   捕捉球の内側に入る。tools/check-sites がプリセット都市についてはその配置を
//   禁じているが、場所検索で名所そのものを出発地にはできてしまう。離陸直後に
//   モーダルが開かないことは、この寸法ではなく historicRings.arm() が担保する。
const RING_RADIUS_M = 250;     // 輪の半径(m)
const RING_CENTER_AGL_M = 350; // 地表から輪の中心までの高さ(m)

// 出発都市原点を基準にした各名所の ENU 座標を前計算する。startGame で一度だけ呼ぶ。
// enu は geo.js createEnuFrame() の戻り値。楕円体正確な変換なので、原点から地球の
// 裏側にある名所でもストリーミングされる 3D タイルと整合する。
// ※ ENU の Y は遠方では「高度」そのものではない（接平面から曲率分ずれる）。
//   latLngToWorld が返す y をそのまま使うのが唯一正しく、curvatureY 補正は不要。
export function sitesToEnu(enu) {
  return HISTORIC_SITES.map((s) => {
    const aglM = s.ringAglM ?? RING_CENTER_AGL_M;
    const p = enu.latLngToWorld(s.lat, s.lng, s.elevationM + aglM);
    return { ...s, x: p.x, y: p.y, z: p.z, radiusM: s.ringRadiusM ?? RING_RADIUS_M };
  });
}

// 最寄りの名所 + 水平距離(m) + 機体→名所の方位(rad, 0=北,+東)。
// 走査そのものは geo.js の nearestPoi（3D 弦距離で順位付け）に任せる。
export function nearestSite(enuSites, x, y, z) {
  const near = nearestPoi(enuSites, x, y, z);
  return near && { site: near.item, distanceM: near.distanceM, bearingRad: near.bearingRad };
}
